export default {
  pageTitle: '问卷管理',
  noAccessAlert: '暂无问卷管理权限，请联系管理员授权。',
  createForm: '新建问卷',
  defaultFormTitle: '未命名问卷',
  searchPlaceholder: '搜索问卷名称',
  /** 问卷列表提示（对齐设计稿） */
  listTip: '预设问卷可在活动报名配置中直接选用；也可按需新建并复用，避免重复设置问卷字段。',
  noDescription: '暂无说明',
  fieldCountLabel: '共 {n} 个字段',
  submissionCountLabel: '已有 {n} 条报名',
  updatedAtLabel: '更新于 {time}',
  editorTitle: '问卷设计',
  tabEdit: '编辑',
  tabSettings: '设置',
  /** 设置页（对齐设计稿「报名设置」分区） */
  settingsPageTitle: '报名设置',
  settingsSectionBasic: '基础设置',
  settingsSectionCopy: '文案设置',
  settingsSectionWechatShare: '微信分享',
  settingsWechatShareTip: '配置好友会话中转发卡片的标题、副标题与封面。随问卷保存；已绑定活动时请到活动「分享」配置。',
  settingsWechatShareBoundTip: '该问卷已绑定活动，微信分享请到活动装修的「分享」中配置。',
  settingsWechatTitle: '分享标题',
  settingsWechatTitlePlaceholder: '可留空，留空则回落为问卷名称',
  settingsWechatSubtitle: '副标题',
  settingsWechatSubtitlePlaceholder: '选填，显示在标题下方',
  settingsWechatImage: '分享图',
  settingsWechatImageHint: '建议尺寸 500×500px，支持 JPG / PNG，大小不超过 3M',
  settingsWechatImageUpload: '上传分享封面',
  settingsWechatImageUploading: '上传中…',
  settingsWechatImageUploadSuccess: '分享图上传成功',
  settingsWechatImageUploadFailed: '分享图上传失败，请稍后重试',
  settingsWechatImageClear: '移除图片',
  settingsWechatImageTypeError: '仅支持 JPG / PNG 图片',
  settingsWechatImageSizeError: '图片大小不能超过 3M',
  settingsWechatNeedSaveFirst: '请先保存问卷后再上传分享图',
  settingsSectionMeetings: '关联会议',
  allowDuplicateTipOn: '开启时：同一人可再次打开已填问卷并修改后重新提交（仍为一条记录）',
  editExistingNotice: '您已提交过本问卷，可修改后重新提交',
  defaultSaveEditText: '保存修改',
  tabStatistics: '统计',
  tabSubmissions: '报名列表',
  /** 报名列表页头（对齐设计稿「报名记录」） */
  submissionRecordsTitle: '报名记录',
  statsTotal: '总报名人数',
  statsPageHint: '本页统计',
  tabOrders: '订单',
  basicFieldTypes: '基础题型',
  commonFieldBank: '常用题库',
  advancedFieldTypes: '高级题型',
  comingSoon: '即将推出',
  addQuestion: '添加问题',
  formDescriptionPlaceholder: '添加描述（选填）',
  formDescriptionImageNotSupported: '问卷描述暂不支持上传图片',
  deleteField: '删除',
  duplicateField: '复制',
  publish: '发布',
  publishConfirm: '确定发布该问卷吗？',
  publishSuccess: '发布成功',
  settingsSubmitText: '提交按钮文案',
  settingsSuccessMessage: '提交成功提示',
  settingsAfterSubmitTitle: '报名成功后显示',
  settingsAfterSubmitEnabled: '开启显示入口',
  settingsAfterSubmitButtonText: '按钮文本（最多8字）',
  settingsAfterSubmitMode: '点击后显示',
  settingsAfterSubmitText: '显示文本内容',
  settingsAfterSubmitImage: '指定图片',
  settingsAfterSubmitLink: '指定链接',
  settingsAfterSubmitContent: '显示内容',
  settingsAfterSubmitUpload: '上传图片',
  settingsAfterSubmitLinkPlaceholder: '请输入 http:// 或 https:// 链接',
  settingsAfterSubmitImageTypeError: '仅支持 JPG、PNG 或 WebP 图片',
  settingsAfterSubmitImageSizeError: '图片大小不能超过 5M',
  settingsAfterSubmitUploadSuccess: '图片上传成功',
  settingsAfterSubmitUploadFailed: '图片上传失败，请稍后重试',
  settingsAfterSubmitButtonInvalid: '请输入不超过8个字的按钮文本',
  settingsAfterSubmitContentRequired: '请输入展示文本',
  settingsAfterSubmitImageRequired: '请上传展示图片',
  settingsAfterSubmitLinkInvalid: '请输入有效的 http 或 https 链接',
  statsEmpty: '暂无提交记录',
  statsParticipant: '填报人',
  statsMeeting: '会议',
  statsLoadFailed: '加载提交记录失败',
  formTitlePlaceholder: '请输入问卷标题',
  fieldPalette: '字段组件',
  fieldProps: '字段属性',
  propLabel: '标题',
  propRequired: '必填',
  propPlaceholder: '占位提示',
  propContent: '说明内容',
  option: '选项',
  addOption: '添加选项',
  removeOption: '删除选项',
  visibilityLabel: '显示条件',
  visibilityNone: '无',
  visibilityHas: '有',
  visibilitySourceField: '依赖字段',
  visibilitySourcePlaceholder: '请选择单选/下拉/多选字段',
  visibilitySourceEmpty: '请在其上方添加单选、下拉或多选字段',
  visibilityValue: '显示值',
  visibilityValuePlaceholder: '请选择选项',
  visibilityWhen: '当 {hint} 时显示',
  visibilityHiddenInPreview: '当前预览条件下此字段隐藏',
  visibilitySaveIncomplete: '字段「{label}」的显示条件未配置完整',
  emptyFields: '拖拽左侧组件到此处，或点击添加',
  dragToAdd: '拖到预览区添加',
  dragSort: '拖拽排序',
  dragToDelete: '拖到此处删除',
  selectFieldHint: '选中字段后可编辑属性',
  previewTitle: '问卷预览',
  backToList: '返回列表',
  publishSettings: '发布设置',
  publishStatus: '发布状态',
  publishStatusTip: '草稿状态下仅可团体报名，发布状态下可同时开启个人报名和团体报名',
  statusDraft: '草稿',
  statusPublished: '已发布',
  boundActivitiesTag: '已绑定活动',
  linkedActivities: '关联活动',
  linkedActivitiesPlaceholder: '不选则仅独立发布',
  linkedActivitiesTip: '可关联多个活动；也可不关联，通过独立链接发布。',
  requireApproval: '是否审核',
  requireApprovalYes: '是',
  requireApprovalNo: '否',
  requireApprovalTip: '选择「否」时，参会人提交后报名审核状态自动为已通过',
  allowDuplicate: '允许修改',
  allowDuplicateMeetingTip: '关闭时：同一人在同一份问卷下只能提交一次',
  allowGroupRegistration: '允许团体报名',
  registrationClosed: '关闭报名入口',
  registrationClosedTip: '开启后关闭 H5 和对接人新增报名，仅活动发起人可在后台手动添加',
  allowGroupRegistrationTip: '开启后可维护对接人名单，由对接人代为录入报名',
  meetingRequired: '缺少会议信息',
  notLinked: '该问卷未绑定此会议，请联系管理员',
  settingsLinkedMeetings: '关联会议',
  settingsLinkedMeetingsPlaceholder: '请选择至少一场会议（可多选）',
  settingsLinkedMeetingsTip: '参会者H5和对接人录入填报时须从中选择一场会议。',
  settingsLinkedMeetingsRequired: '请至少选择一场关联会议',
  selectMeetingLabel: '选择会议场次（可多选）',
  selectMeetingPlaceholder: '请选择要报名的会议（可多选）',
  selectMeetingRequired: '请至少选择一场会议',
  selectMeetingStepTip: '请选择要报名的会议场次（可多选），确认后再填写问卷。',
  selectMeetingMultiTip: '已选 {count} 场会议',
  selectProxyLabel: '对接人',
  selectProxyPlaceholder: '请选择对接人（可不选）',
  selectProxyOptionalTip: '可选；仅展示当前所选会议范围内的已发布对接人',
  selectProxyGroupLabel: '所属团体',
  selectProxyGroupPlaceholder: '请选择所属团体',
  selectProxyGroupTip: '请选择当前活动下已发布的对接人团体',
  selectProxyGroupOptionalTip: '选填，可选择当前活动下已发布的对接人团体，无所属团体可留空',
  selectProxyGroupRequired: '请选择所属团体',
  proxyFilterProxyBatch: '对接人',
  h5BatchSubmitSuccess: '已成功为 {count} 个会议场次提交报名',
  noLinkedMeetingsHint: '该问卷尚未关联会议场次，请联系主办方在「报名管理 → 设置」中关联会议并保存。',
  defaultSubmitText: '提交报名',
  standalone: '独立发布',
  activityCount: '{count} 个活动',
  colTitle: '问卷名称',
  colStatus: '状态',
  colActivities: '关联活动',
  colApproval: '需审核',
  colDuplicate: '可重复',
  colSubmissions: '提交数',
  colUpdated: '更新时间',
  editForm: '进入',
  preview: '预览',
  previewDialogTitle: '报名链接预览',
  previewDialogTip: '扫码或复制下方链接访问报名页；H5 填报需先登录（邮箱/手机/微信）。',
  previewBlockedWhenBound: '已绑定活动，请到「活动装修页面」浏览',
  previewMeetingPlaceholder: '选填：输入会议 ID 生成带参链接',
  previewMeetingRequired: '请输入有效的会议 ID',
  previewApplyMeeting: '生成链接',
  fieldPresets: '常用字段',
  propPattern: '校验正则',
  propPatternPlaceholder: '如 ^(?:\\+?86)?1[3-9]\\d{9}$|^\\+[1-9]\\d{6,14}$（留空则不校验）',
  propPatternMessage: '校验失败提示',
  propPatternMessagePlaceholder: '用户可自行填写提示文案',
  propMin: '最小值',
  propMax: '最大值',
  propUnit: '单位',
  propIdCard: '身份证校验',
  propIdCardUnique: '是否唯一',
  propDateType: '日期类型',
  dateTypeDate: '日期',
  dateTypeMonth: '年月',
  dateTypeDatetime: '日期时间',
  dateTypeTime: '时间',
  propDetailPlaceholder: '详细地址占位',
  addressRegionPlaceholder: '请选择省/市/区',
  addressDetailPlaceholder: '街道、门牌号等',
  presetName: '姓名',
  presetWeight: '体重',
  presetTime: '时间',
  presetEducation: '学历',
  presetPassportNumber: '护照号码',
  presetPhone: '手机号',
  presetGender: '性别',
  presetIdCard: '身份证号',
  presetBirthDate: '出生年月',
  presetEmail: '邮箱',
  presetYesNo: '是否',
  presetFeeItem: '收费项',
  presetWechat: '微信号',
  feeAudienceLabel: '适用对象',
  feeAudienceGuest: '散客',
  feeAudienceProxy: '对接人',
  feeAudienceTip: '散客：H5/微站报名可见；对接人：代填录入可见。用于后期按渠道统计与生成订单。',
  feeItemOptionPriceHint: '右侧填写金额，单位为元（可含小数，最多两位）；选项 ID 自动生成且不可见',
  feeItemOptionPricePlaceholder: '金额（元）',
  feeItemOptionPriceInvalid: '金额须为非负数，最多两位小数（单位：元）',
  feeItemOptionPriceSaveError: '「{label}」第 {n} 个选项金额无效，请填写非负金额（单位：元）',
  presetAddress: '地址',
  fieldInput: '单行文本',
  fieldTextarea: '多行文本',
  fieldNumber: '数字',
  fieldDate: '日期',
  fieldAddress: '地址',
  fieldCheckbox: '多选项',
  fieldRadio: '单选项',
  fieldSelect: '下拉选择',
  fieldMeeting: '会议日程',
  fieldHotel: '酒店',
  meetingOptionsTip: '问卷已关联活动：从活动议程中勾选要展示的日程；参会者在问卷页勾选即表示参加。',
  meetingSelectLabel: '选择议程',
  meetingMultiple: '是否多选',
  meetingSelectPlaceholder: '请选择要展示的议程',
  meetingEmptyList: '关联活动暂无议程，请先在活动设置中添加',
  meetingOptionsCount: '已选 {n} 个议程',
  meetingSyncFailed: '加载活动议程失败',
  meetingCardTime: '时间',
  meetingCardAddress: '地址',
  meetingCardPlace: '地点',
  hotelPlaceholder: '请选择酒店',
  hotelSelectAsNeeded: '请按需选择',
  hotelOptionsTip: '从酒店库勾选本活动酒店；勾选后自动同步房型。未填金额的房型不会出现在 H5（不回落酒店库价）。',
  hotelRoomPriceTip: '金额单位：元（可含小数，最多两位）。同步房型时会带入库价作初值，可按活动改价。',
  hotelRoomPricePlaceholder: '金额（元）',
  hotelNoRoomsInOption: '该酒店暂无房型，请先在酒店库维护房型后再刷新。',
  hotelSelectLabel: '选择酒店',
  hotelSelectPlaceholder: '勾选酒店后自动同步房型',
  hotelRefreshRooms: '刷新已选房型',
  hotelRefreshRoomsSuccess: '已刷新房型（已填金额已保留）',
  hotelSyncOptions: '同步酒店列表',
  hotelOptionsCount: '已同步 {n} 家酒店',
  hotelSyncSuccess: '酒店列表已同步',
  hotelSyncFailed: '同步酒店列表失败',
  hotelEmptyList: '暂无可选酒店',
  hotelViewDetail: '查看酒店',
  hotelStayDates: '入住时间',
  hotelCheckIn: '入住日期',
  hotelCheckOut: '离店日期',
  hotelStayRangePlaceholder: '请选择入住与离店日期',
  hotelAccommodationTitle: '是否随行酒店住宿',
  hotelAccommodationTip: '本活动提供优质的酒店住宿服务，欢迎订购',
  hotelClearSelection: '清空选择',
  hotelOpenList: '打开酒店列表',
  hotelSelectionTitle: '选择酒店住宿',
  hotelSelectedStays: '已选择 {count} 段入住',
  hotelIncompleteStay: '请完整选择每段入住时间和房型，离店日期须晚于入住日期',
  hotelStayRangeConfirm: '确定',
  hotelNoRooms: '暂无可用房型',
  hotelAddStay: '新增入住时间',
  hotelRemoveStay: '删除',
  hotelPerNight: '晚',
  hotelBreakfastInclude: '含早餐',
  hotelBreakfastExclude: '不含早餐',
  hotelBreakfastOptional: '早餐可选',
  hotelAddress: '地址',
  hotelPhone: '电话',
  hotelStar: '星级',
  hotelFacilities: '酒店设施',
  hotelPackages: '酒店套餐',
  hotelSurroundings: '周边环境',
  fieldDivider: '分割线',
  fieldDescription: '说明文字',
  advancedMeeting: '会议日程',
  advancedFile: '文件题',
  advancedSignature: '签名题',
  advancedMatrix: '矩阵题',
  advancedScale: '量表题',
  advancedRating: '评分题',
  titleRequired: '请输入问卷标题',
  loadFailed: '加载失败',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  createSuccess: '创建成功',
  createFailed: '创建失败',
  copySuccess: '复制成功',
  copyFailed: '复制失败',
  deleteConfirm: '确定删除表单「{name}」吗？',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  goLogin: '去登录',
  loginDialogTitle: '登录后报名',
  validateFailed: '请完善必填项',
  submitSuccess: '提交成功',
  submitFailed: '提交失败',
  quotaFullAlertTitle: '名额已满',
  quotaFullAlertConfirm: '知道了',
  duplicateReadonly: '您已提交过，请勿重复报名',
  submittedAt: '提交时间',
  submissionStatusPending: '待审核',
  submissionStatusApproved: '已通过',
  submissionStatusRejected: '已拒绝',

  /** 对接人录入 · 名单管理（设置 Tab） */
  proxyBatchTitle: '对接人名单',
  /** 信息条（对齐设计稿对接人卡片顶部提示） */
  proxyBatchDesignTip: '对接人可代其名下成员批量录入报名信息，每位对接人独立管理其组内名单。',
  proxyBatchTip: '维护代填人员后，勾选需要发邀请的对接人，再点击「发送邀请」。邮件仅含 Magic Link，对接人需用自己的账号登录。已发送过的也可勾选后再次发送。与问卷「发布」无关。',
  proxyImportExcel: 'Excel 导入',
  proxyExportExcel: '导出 Excel',
  proxyExportExcelEmpty: '暂无对接人可导出',
  proxyExportExcelSuccess: '已导出 {count} 条对接人',
  proxyExportExcelFailed: '导出失败，请稍后重试',
  proxyAddRow: '+ 新增对接人',
  proxyEditRow: '编辑名单',
  proxyMailTemplate: '邮件模板',
  proxyMailTemplateNeedActivity: '请先绑定活动后再配置邮件模板',
  proxyPublishBatches: '发送邀请',
  proxyPublishFormFirst: '请先将问卷发布为「已发布」，再发送邀请。',
  proxyPublishWhileDraftTip: '问卷为草稿时也可发送邀请；参会者公开报名仍须将问卷设为已发布/启用。',
  showHistoricalColumns: '显示已删除字段列',
  proxyPublishConfirm: '确定向当前筛选条件下的对接人发送邀请吗？将创建/更新对接人账号并发送邮件。',
  proxyPublishSelectFirst: '请先勾选要发送邀请的对接人',
  proxyPublishConfirmSelected: '确定向所选 {count} 位对接人发送邀请吗？已发送过的将重新发邮件。',
  proxyPublishSuccess: '邀请发送成功',
  proxyPublishFailed: '邀请发送失败',
  proxyFilterStatus: '邀请状态',
  proxyStatusDraft: '未邀请',
  proxyStatusPublished: '已邀约',
  proxyColName: '姓名',
  proxyColGroupName: '团体名称',
  proxyGroupNamePlaceholder: '选填；不填则用对接人姓名',
  proxyColMagicLink: 'Magic Link',
  proxyMagicLinkCopied: '邀请链接已复制',
  proxyMagicLinkCopyFailed: '复制失败，请手动选择链接',
  proxyColPhone: '手机',
  proxyColJobTitle: '职务',
  proxyColNotifyEmail: '通知邮箱',
  proxyColMeeting: '会议',
  proxyColActivity: '活动',
  proxyColQuota: '名额',
  proxyColMaxRegistrations: '名额上限',
  proxyMaxRegistrationsTip: '留空表示不限制；满额后该对接人代填 / H5 挂靠提交将失败',
  proxyQuotaUnlimited: '{used} / 不限',
  proxyQuotaUsedOfMax: '{used} / {max}',
  proxyQuotaUnlimitedShort: '不限',
  proxyEditQuotaTitle: '修改报名名额',
  proxyColQuotaUsed: '已用名额',
  proxyQuotaSaveSuccess: '名额已更新',
  proxyQuotaSaveFailed: '名额更新失败',
  proxyQuotaBelowUsed: '名额不能小于已用数量（{used}）',
  proxySelectActivity: '请选择活动',
  proxySelectActivities: '请选择活动（可多选）',
  proxyImportExcelTip: 'Excel 列：团体名称、姓名、手机、职务、通知邮箱、活动ID、名额上限（可选，留空不限制）。团体名称留空时用姓名兜底。导入为追加。请先下载模板。单次最多 1000 行。',
  proxyImportExcelTemplate: '下载 Excel 模板',
  proxyImportExcelDrop: '拖拽 Excel 文件到此处，或点击上传（.xlsx / .xls）',
  proxyImportExcelPreview: '已解析 {count} 行有效数据',
  proxyImportExcelTypeError: '请上传 .xlsx 或 .xls 文件',
  proxyImportExcelParseFailed: 'Excel 解析失败，请检查文件格式',
  proxyImportExcelNoActivity: '暂无可用活动，无法生成模板中的活动 ID',
  proxyColPublishStatus: '邀请状态',
  proxyColRegistrationStatus: '注册状态',
  proxyRegistrationRegistered: '已注册',
  proxyRegistrationUnregistered: '未注册',
  proxyColMailStatus: '邮件状态',
  proxyColAccountEmail: '对接人账号',
  proxyResendMail: '重发邮件',
  proxyResendConfirmTitle: '确认重发邀请邮件',
  proxyResendConfirmBound: '重发「{name}」的邀请邮件会清除当前账号与此名单的绑定，列表将显示为未注册。对接人需使用新邀请链接重新激活；已有报名记录不会删除。确定重发吗？',
  proxyResendConfirmUnbound: '重发「{name}」的邀请邮件会使旧邀请链接失效，并发送新的链接。确定重发吗？',
  proxyResendSuccess: '邮件已重发',
  proxyResendFailed: '重发失败',
  proxyMailPending: '待发送',
  proxyMailSent: '已发送',
  proxyMailFailed: '发送失败',
  proxyMailPolling: '正在刷新邮件发送状态…',
  proxyNameRequired: '请填写姓名',
  proxyEmailRequired: '请填写通知邮箱',
  proxyEmailInvalid: '邮箱格式不正确',
  proxyLoadFailed: '加载对接人名单失败',
  proxyCreateSuccess: '已添加名单',
  proxyCreateBatchSuccess: '已添加 {count} 条名单',
  proxyDeleteConfirm: '确定删除「{name}」吗？',
  proxyImportSubmit: '导入',
  proxyImportEmpty: '未解析到有效行',
  proxyImportTooMany: '单次导入不能超过 1000 行',
  proxyImportSuccess: '已追加导入',

  /** 对接人录入 · 录入页 / Magic Link */
  proxyAgentLabel: '对接人',
  proxyContinueEntry: '继续录入下一位',
  proxyLogoutConfirm: '确定退出登录吗？',
  proxyConsumeLoading: '正在验证登录链接…',
  proxyConsumeInvalid: '链接无效或已过期，请联系管理员重新发送。',
  proxyConsumeFailed: '验证登录链接失败，请稍后重试。',
  proxyConsumeLoginRequired: '请先登录后再进入录入页。',
  proxyInviteSubtitle: '请使用您自己的账号登录或注册，登录后将自动开通对接权限',
  proxyInviteTitle: '对接录入：{form}',
  proxyInviteAccount: '登录账号',
  proxyInviteInvalid: '邀请无效或已过期',
  proxyInviteForbidden: '该邀请链接已被其他账号使用，请退出当前账号后重试',
  proxyLoginMustProxy: '请打开邮件中的邀请链接完成登录',
  proxyActivateSuccess: '激活成功，正在进入录入页',
  proxyActivateFailed: '激活失败，请确认使用邮件链接登录后再试',
  proxyRegisterHint: '自行注册为普通账号，不会激活对接录入',
  proxyRegisterInviteNote: '邮箱注册需验证邮件，暂不会自动激活对接权限；建议使用手机号注册或返回登录页。',
  proxyEntryHintTitle: '请使用邮件中的录入链接',
  proxyEntryHintDesc: '对接人需通过管理员发送的 Magic Link 进入；若已收到邮件，请点击邮件中的链接，使用自己的账号登录或注册。',
  proxyGrantPending: '请登录或注册您的账号，登录成功后将自动开通对接录入权限。',
  proxyGrantMagicLinkHint: '邮件中的链接仅用于授权，不含账号密码。请使用邮箱、手机号或微信扫码登录，成功后进入活动列表。',
  proxyGrantWechatDefault: '可使用微信扫码、邮箱或手机号登录；登录成功后将自动开通对接权限。',
  proxyGrantWechatRequired: '账号验证成功，请使用微信扫码完成登录',
  proxyGrantWechatBindBeforeLogin: '请先扫码关注服务号，将微信与邮件账号绑定后再登录',
  proxyGrantWechatBoundRelogin: '微信绑定成功，请使用邮箱密码登录并完成激活',
  proxyGrantWechatBindFailed: '该微信无法关联到当前对接人账号，请更换微信或联系管理员',
  proxyGrantWechatBindIncomplete: '微信绑定未完成，请重新扫码',
  proxyGrantWechatRebindPending: '检测到微信绑定冲突，请在弹窗中确认…',
  proxyGrantWechatRebindTitle: '微信绑定冲突',
  proxyGrantWechatRebindMessage: '该微信已绑定其他邮箱账号，是否解绑旧账号并绑定当前邮件账号？',
  proxyGrantWechatRebindTarget: '当前邮件账号：{email}',
  proxyGrantWechatRebindBound: '已绑定账号：{email}',
  proxyGrantWechatRebindConfirm: '解绑并绑定',
  proxyGrantConsumed: '该链接已激活，请直接使用您的账号登录。',
  proxyGrantExpired: '链接已过期，请联系管理员重新发送邀请邮件。',
  proxyAccessRequiresInvite: '该账号尚未通过邮件邀请完成授权，请打开邮件中的邀请链接',
  proxyFormListEmpty: '暂无授权问卷，请联系管理员',
  proxyEntryAction: '代填',
  proxyEnterAction: '进入',
  listEmpty: '暂无问卷',
  proxyEntryMeetingTitle: '选择会议场次',
  proxyEntryMeetingTip: '请从问卷已关联的会议中选择本次代填对应的场次，提交时将关联该会议。',
  proxyEntryMeetingLabel: '会议场次',
  proxyEntryMeetingPlaceholder: '请选择会议场次',
  proxyEntryMeetingRequired: '请先选择会议场次',
  proxyEntryMeetingMultiTip: '已选 {count} 场会议',
  proxyEntryMeetingEditTip: '编辑时不可更改会议场次',
  proxyForbidden: '您没有该问卷的对接录入授权',
  proxyBackFormList: '返回问卷列表',
  proxyWorkbenchNav: '对接人工作台导航',
  proxyNavRegistrations: '报名',
  proxyNavOrders: '订单',
  proxySubmissionListTitle: '代填记录',
  proxySubmissionListSubtitle: 'H5 报名提交；对接人仅见指定给自己的记录',
  submissionListSubtitle: '参会者 H5 报名提交；可筛选状态、会议与对接人',
  reviewApprove: '通过',
  reviewReject: '拒绝',
  reviewApproveConfirm: '确定通过该报名吗？',
  reviewRejectTitle: '拒绝报名',
  reviewRemarkPlaceholder: '备注（可选）',
  reviewApproveSuccess: '已通过',
  reviewRejectSuccess: '已拒绝',
  submissionEditTitle: '编辑报名提交',
  submissionDetailTitle: '参与人详情',
  submissionDetailSectionBasic: '报名信息',
  submissionDetailSectionMore: '其他信息',
  submissionTypeLabel: '报名类型',
  submissionTypeIndividual: '个人',
  submissionTypeTeam: '团队',
  submissionTypeTeamOf: '{team}',
  submissionMeetingReadonlyTip: '所选会议不可修改，仅可编辑问卷内容。',
  submissionDeleteConfirm: '确定删除该报名提交吗？删除后该用户可再次 H5 报名。',
  submissionDeleteSuccess: '已删除',
  proxySubmissionListEmpty: '暂无报名提交',
  proxySubmissionKeywordPlaceholder: '搜索姓名、手机等',
  proxyFilterActivity: '按活动筛选',
  proxyFilterSubmissionStatus: '审核状态',
  proxyColSubmittedAt: '提交时间',
  submissionColSource: '报名来源',
  submissionSourceH5: '自主报名',
  submissionSourceProxy: '受邀报名',
  submissionColPaymentStatus: '支付状态',
  submissionPaymentStatusNone: '未下单',
  proxyAddEntry: '录入',
  /** 管理端报名列表 · 手动录入（复用代填提交接口） */
  adminAddEntry: '录入',
  submissionExport: '导出',
  submissionExportEmpty: '当前筛选条件下暂无可导出的报名记录',
  submissionExportSuccess: '已导出 {count} 条报名记录',
  submissionExportFailed: '导出报名记录失败，请稍后重试',
  proxyEditEntry: '编辑代填',
  proxySubmitEntry: '提交',
  proxyOrdersPlaceholder: '订单功能开发中，敬请期待',
  proxyBatchSubmitSuccess: '已成功提交 {count} 条代填记录',

  /** 报名订单（B 端） */
  orderRecordsTitle: '报名费订单',
  statsOrderTotal: '订单总数',
  /** 本页：已退款 + 部分退款 */
  statsOrderRefunded: '退款相关',
  orderListSubtitle: '本问卷下的报名订单；对接人仅可见本人创建的订单',
  orderFilterStatus: '订单状态',
  orderColId: '订单号',
  orderColStatus: '状态',
  orderColAmount: '金额',
  orderColItemCount: '明细数',
  orderColCreatedAt: '创建时间',
  orderViewDetail: '详情',
  orderCancel: '取消订单',
  orderCancelConfirm: '确定取消该订单吗？仅待支付订单可取消。',
  orderCancelSuccess: '订单已取消',
  orderListEmpty: '暂无订单',
  orderDetailTitle: '订单详情',
  orderItemsTitle: '订单明细',
  orderCreate: '创建订单',
  orderCreateSuccess: '订单已创建',
  orderCreateFailed: '创建订单失败',
  orderSelectedCount: '已选 {count} 条',
  orderStatusPendingPayment: '待支付',
  orderStatusPaid: '已支付',
  orderStatusPartiallyRefunded: '部分退款',
  orderStatusCancelled: '已取消',
  orderStatusRefunded: '已退款',

  /** 报名订单 · 部分退款 */
  orderColRefundedAmount: '已退金额',
  orderItemRefundStatus: '退款状态',
  orderItemRefundNone: '未退',
  orderItemRefundRefunding: '退款中',
  orderItemRefundRefunded: '已退',
  orderItemRefundFailed: '失败',
  orderRefund: '申请退款',
  orderRefundTitle: '订单部分退款',
  orderRefundSelectedCount: '已选 {count} 条明细',
  orderRefundAmountLabel: '本次退款金额',
  orderRefundReasonLabel: '退款原因',
  orderRefundReasonPlaceholder: '选填，最长 256 字',
  orderRefundTip: '按所选明细整行原路退回微信；已退款的报名可再次创建订单。',
  orderRefundConfirm: '确认退款',
  orderRefundSuccess: '退款申请已提交',
  orderRefundFailed: '退款失败，请稍后重试',
  orderRefundProcessingTip: '订单有明细正在退款处理中，请稍后再试',

  /** 报名订单 · 微信 Native 支付 */
  orderPay: '去支付',
  orderPayTitle: '微信扫码支付',
  orderPayAmountLabel: '应付金额',
  orderPayScanTip: '请使用微信扫一扫完成支付',
  orderPayCountdown: '二维码有效期 {time}',
  orderPayReusedTip: '已复用当前有效支付码',
  orderPayPolling: '正在等待支付结果…',
  orderPaySuccess: '支付成功',
  orderPayFailed: '发起支付失败，请稍后重试',
  orderPayNoCodeUrl: '未获取到支付二维码，请稍后重试',
  orderPayCancelled: '订单已取消或支付已过期，请重新创建订单'
}
